"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormAction = void 0;
const ot_1 = require("../engine/ot");
const lodash_1 = require("lodash");
class FormAction {
    // update own properties
    static updatePropsAction(formProps, options) {
        const { partialProps } = options;
        const actions = [];
        for (const key in partialProps) {
            const oi = partialProps[key];
            const od = formProps[key];
            if (!(0, lodash_1.isEqual)(oi, od)) {
                actions.push({
                    n: ot_1.OTActionName.ObjectReplace,
                    p: ['formProps', key],
                    oi,
                    od,
                });
            }
        }
        return actions;
    }
}
exports.FormAction = FormAction;
//# sourceMappingURL=form.js.map